module.exports = __webpack_public_path__ + "caac1fc6d557f2a1871e3c9b132852a4.png";